module.exports = __webpack_public_path__ + "img/link_white_24dp.793a33b6.svg";